import { Content } from "models/content";

export enum VODUploadType {
    DIRECT = "DIRECT",
    MULTIPART = "MULTIPART"
}

export interface S3MultipartUploadData {
	bucket: string,
	fileKey: string
	uploadId: string
}

export interface UploadContentResponse {
	content: Content;
	uploadType: VODUploadType;
	s3PresignedUploadUrl?: string;
	s3MultipartUploadData?: S3MultipartUploadData;
	s3PresignedThumbnailUrl: string;
	s3PresignedSubtitlesFileList?: string[];
}
